package com.example.readingnotes.data.repository

import com.example.readingnotes.data.remote.api.ApiClient
import com.example.readingnotes.data.remote.dto.StripeConnectCallbackResponseDto
import com.example.readingnotes.data.remote.dto.StripeConnectStatusDto
import com.example.readingnotes.domain.model.*
import com.example.readingnotes.domain.repository.StripeConnectRepository
import com.example.readingnotes.util.Result

class StripeConnectRepositoryImpl(
    private val apiClient: ApiClient,
) : StripeConnectRepository {
    override suspend fun getOnboardingLink(
        redirectUrl: String,
        refreshUrl: String?,
    ): Result<OnboardingLink> =
        try {
            val response = apiClient.getStripeConnectOnboardingLink(redirectUrl, refreshUrl)
            Result.success(
                OnboardingLink(
                    url = response.url,
                    stripeAccountId = response.stripeAccountId,
                ),
            )
        } catch (e: Exception) {
            Result.failure(e)
        }

    override suspend fun getAccountStatus(): Result<StripeConnectStatus> =
        try {
            val response = apiClient.getStripeConnectStatus()
            Result.success(response.toDomain())
        } catch (e: Exception) {
            Result.failure(e)
        }

    override suspend fun handleCallback(code: String): Result<StripeConnectCallbackResult> =
        try {
            val response = apiClient.handleStripeConnectCallback(code)
            val status = apiClient.getStripeConnectStatus()
            Result.success(
                StripeConnectCallbackResult(
                    success = response.success,
                    accountId = response.accountId,
                    onboardingCompleted = response.onboardingCompleted,
                    status = status.toDomain(),
                ),
            )
        } catch (e: Exception) {
            Result.failure(e)
        }

    override suspend fun refreshAccountStatus(): Result<StripeConnectStatus> =
        try {
            val response = apiClient.refreshStripeConnectStatus()
            Result.success(response.toDomain())
        } catch (e: Exception) {
            Result.failure(e)
        }
}

// Extension functions for DTO to Domain mapping
fun StripeConnectStatusDto.toDomain(): StripeConnectStatus =
    StripeConnectStatus(
        connected = connected,
        chargesEnabled = chargesEnabled,
        payoutsEnabled = payoutsEnabled,
        onboardingCompleted = onboardingCompleted,
        detailsSubmitted = detailsSubmitted,
        country = country,
        stripeAccountId = stripeAccountId,
    )

fun StripeConnectCallbackResponseDto.toDomain(): StripeConnectCallbackResult =
    StripeConnectCallbackResult(
        success = success,
        accountId = accountId,
        onboardingCompleted = onboardingCompleted,
    )
